export default __webpack_public_path__ + "static/media/expertise.8b2687e1.jpg";